export default __webpack_public_path__ + "static/media/knight-modal.938ff347.svg";